import { applyHomeCopy } from "./home-copy-apply";
import { initFooterContact } from "./footer-contact";
import { initHeaderInstagramLink } from "./header-social";
import { initCarousels } from "./carousel";
import { renderCatalogoPage } from "./pages/render-catalogo";
import { renderColeccionesPage } from "./pages/render-colecciones";
import { renderProductoPage } from "./pages/render-producto";
import { renderHomeFeaturedProducts } from "./pages/render-home-featured";

export function initDataDrivenPages(): void {
  if (document.body.dataset.page === "proximamente") {
    initFooterContact();
    initHeaderInstagramLink();
    return;
  }

  applyHomeCopy();
  initFooterContact();
  initHeaderInstagramLink();
  renderHomeFeaturedProducts();
  renderCatalogoPage();
  renderColeccionesPage();
  renderProductoPage();
  initCarousels();
}
